import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import { getCustomerPendingGI } from "../../../../../services/sales/customerService";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../../utils/utils";
import { Card } from "primereact/card";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";

const CustomerPendingGIs = ({ customerID, history }) => {
  const { reload } = useGlobalData();
  const [auth, setAuth] = useState({});
  const [customerPendingGI, setCustomerPendingGI] = useState([]);
  const [fullyIssuedItems, setFullyIssuedItems] = useState(0);
  const [partiallyIssuedItems, setPartiallyIssuedItems] = useState(0);
  const [unissuedItems, setUnissuedItems] = useState(0);

  useEffect(() => {
    getCustomerPendingGIData();
  }, [customerID, reload]);

  async function getCustomerPendingGIData() {
    const response = await getCustomerPendingGI(customerID);
    const { data, auth } = response.data;
    setCustomerPendingGI(data.salesOrders);
    setAuth(auth);

    const fullyIssuedItems = data.salesOrders.filter(
      (pendingGI) => pendingGI.giStatus === 3
    );
    const partiallyIssuedItems = data.salesOrders.filter(
      (pendingGI) => pendingGI.giStatus === 2
    );
    const unissuedItems = data.salesOrders.filter(
      (pendingGI) => pendingGI.giStatus === 1
    );
    setFullyIssuedItems(fullyIssuedItems.length);
    setPartiallyIssuedItems(partiallyIssuedItems.length);
    setUnissuedItems(unissuedItems.length);
  }

  const customerPendingGIDetailColumn = [
    {
      header: "Expected Delivery Date",
      field: "expDeliveryDate",
      type: "date",
    },
    {
      header: "Quotation ID",
      field: "quotationCode",
      type: "string",
    },
    {
      header: "Sales Agent",
      field: "salesName",
      type: "string",
    },
    {
      header: "Customer PO Number",
      field: "customerPoNo",
      type: "string",
    },
    {
      header: "Exchange Rate To Base Currency",
      field: "exchangeRate",
      type: "currency",
    },
    {
      header: "Approval Status",
      field: "approvalStatusDesc",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-6 col-md-6 col-lg-6">
          <Card id="overviewcard" className="border-warning">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-exclamation-circle kt-font-warning" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">
                    PARTIALLY ISSUED
                  </div>
                </div>
                <Badge variant="warning">{partiallyIssuedItems}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <Card id="overviewcard" className="border-danger">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-times-circle kt-font-danger" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">UNISSUED</div>
                </div>
                <Badge variant="danger">{unissuedItems}</Badge>
              </div>
            </div>
          </Card>
        </div>
      </div>
      {customerPendingGI.length ? (
        <React.Fragment>
          <CustomDataTable
            data={customerPendingGI}
            dataDetailColumns={customerPendingGIDetailColumn}
            onRefreshData={() => {
              getCustomerPendingGIData(customerID);
            }}
            columns={[
              {
                header: "Sales Order ID",
                field: "salesOrderCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Order Date",
                field: "orderDate",
                body: (rowData) => formatDate(rowData.orderDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Goods Issue Status",
                field: "giStatusDesc",
                body: (rowData) => {
                  if (rowData.giStatus === 1) {
                    return (
                      <Badge variant="danger">{rowData.giStatusDesc}</Badge>
                    );
                  } else if (rowData.giStatus === 2) {
                    return (
                      <Badge variant="warning">{rowData.giStatusDesc}</Badge>
                    );
                  } else if (rowData.giStatus === 3) {
                    return (
                      <Badge variant="success">{rowData.giStatusDesc}</Badge>
                    );
                  } else {
                    return <Badge variant="dark">{rowData.giStatusDesc}</Badge>;
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Invoice Status",
                field: "invoiceStatusDesc",
                body: (rowData) => {
                  if (rowData.invoiceStatus === 1) {
                    return (
                      <Badge variant="danger">
                        {rowData.invoiceStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.invoiceStatus === 2) {
                    return (
                      <Badge variant="warning">
                        {rowData.invoiceStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.invoiceStatus === 3) {
                    return (
                      <Badge variant="success">
                        {rowData.invoiceStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.invoiceStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Grand Total",
                field: "grandTotal",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.grandTotal}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.view ? (
                      <BootstrapTooltip title="Sales Order Detail">
                        <button
                          type="button"
                          onClick={() => {
                            history.push(
                              "/sales/sales-order/sales-order-detail/" +
                                rowData.ID
                            );
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-list-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Procurement.png"
            guidance="You don't have any Pending Goods Issued for this customer yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CustomerPendingGIs;
